module.exports = __webpack_public_path__ + "static/AxaColpatria2-027b2ed22f825a9bfb501af04f16c48a.png";